export default __webpack_public_path__ + "static/p2-b7e19c9b8c85d4c7f1348f0623e4eb05.jpg";